import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import CreateEvent from "./pages/couple/CreateEvent";
import VendorEntry from "./pages/couple/VendorEntry";
import Story from "./pages/couple/Story";
import SubmitStory from "./pages/submit/SubmitStory";
import Confirmation from "./pages/couple/Confirmation";
import LegalPage from "./pages/Legal";
import ProSubmit from "./pages/submit/ProSubmit";
import SubmitterLogin from "./pages/submit/SubmitterLogin";
import VerifyMagic from "./pages/submit/VerifyMagic";
import MySubmissions from "./pages/submit/MySubmissions";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminForgotPassword from "./pages/admin/AdminForgotPassword";
import AdminResetPassword from "./pages/admin/AdminResetPassword";
import AdminSetPassword from "./pages/admin/AdminSetPassword";
import AdminLayout from "./pages/admin/AdminLayout";
import Team from "./pages/admin/Team";
import Account from "./pages/admin/Account";
import Dashboard from "./pages/admin/Dashboard";
import Events from "./pages/admin/Events";
import EventDetail from "./pages/admin/EventDetail";
import Vendors from "./pages/admin/Vendors";
import VendorDetail from "./pages/admin/VendorDetail";
import ReviewVendors from "./pages/admin/ReviewVendors";
import ToDo from "./pages/admin/ToDo";
import Settings from "./pages/admin/Settings";
import PartnerSync from "./pages/admin/PartnerSync";
import Tracking from "./pages/admin/Tracking";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<CreateEvent />} />

            <Route path="/create-event" element={<CreateEvent />} />
            <Route path="/create-event/:id/edit" element={<CreateEvent />} />
            <Route path="/create-event/:id/vendors" element={<VendorEntry />} />
            <Route path="/create-event/:id/story" element={<Story />} />
            <Route path="/create-event/:id/submit" element={<SubmitStory />} />
            <Route path="/create-event/:id/done" element={<Confirmation />} />
            <Route path="/pro/new" element={<ProSubmit />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/cookies" element={<LegalPage kind="cookies" />} />
            <Route path="/login" element={<SubmitterLogin />} />
            <Route path="/auth/verify" element={<VerifyMagic />} />
            <Route path="/my-submissions" element={<MySubmissions />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin/set-password" element={<AdminSetPassword />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="events" element={<Events />} />
              <Route path="events/:id" element={<EventDetail />} />
              <Route path="todo" element={<ToDo />} />
              <Route path="vendors" element={<Vendors />} />
              <Route path="vendors/review" element={<ReviewVendors />} />
              <Route path="vendors/:id" element={<VendorDetail />} />
              <Route path="tracking" element={<Tracking />} />
              <Route path="settings" element={<Settings />} />
              <Route path="tools/partner-sync" element={<PartnerSync />} />
              <Route path="team" element={<Team />} />
              <Route path="account" element={<Account />} />
            </Route>

            <Route path="*" element={<Navigate to="/create-event" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
